import React from 'react';
import Marquee from "react-fast-marquee";
import './marquee.css';
import { mothersday } from './imports';


const marquee = () => {
  return (
    <div className='gpt3__marquee-component'>
      <Marquee pauseOnHover={true} speed={40} gradient={false}>

          <div className='gpt3__marquee-component-content'>
          <img className="gpt3__marquee-image" src={mothersday} alt="Happy Mother's Day greeting"/>
          <div className='gpt3__marquee-component-text'>
          Happy Mother's Day! Celebrating all the amazing women in our community</div>
          <img className="gpt3__marquee-image" src={mothersday} alt="Happy Mother's Day greeting"/>
          </div>
          
        </Marquee>
    </div>
  )
}


export default marquee
